var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { memo } from 'react';
import VpnKeyOffOutlinedIcon from '@mui/icons-material/VpnKeyOffOutlined';
import { ProjectStatus } from 'root/src/shared/@types/project';
import { useCreateProjectDropMutation } from 'root/src/client/v2/drop/hooks/useCreateProjectDropMutation';
import { useRedesignModal } from 'root/src/client/v2/common/contexts/redesignModal.context';
import { useAsyncAction } from 'root/src/client/v2/common/hooks/useAsyncAction';
import { RedesignModalShell } from 'root/src/client/v2/common/components/RedesignModalShell';
import { RedesignPendingProjectModal } from 'root/src/client/v2/drop/features/KeySelectionModal/components/RedesignPendingProjectModal';
import { Button } from 'root/src/client/v2/common/components/ui/button';
const isLegacyError = (err) => (typeof err === 'object' && err !== null && 'error' in err);
// Shown when a creator accepts a drop whose initial product (join key) is depleted. Confirms they
// want to join now without the key: they stay on the waitlist and get the key if the brand restocks.
export const RedesignNoInitialKeysModal = memo(({ payload, onSuccess }) => {
    const modal = useRedesignModal();
    const createProjectDropMutation = useCreateProjectDropMutation();
    const { loading, success, error, run } = useAsyncAction();
    const onConfirm = () => {
        void run(() => __awaiter(void 0, void 0, void 0, function* () {
            const project = yield createProjectDropMutation.mutateAsync(Object.assign(Object.assign({}, payload), { acceptWithoutInitialProduct: true }));
            if (project.status === ProjectStatus.Pending) {
                modal.show(<RedesignPendingProjectModal />);
                return;
            }
            modal.hide();
        }), {
            // Success closes the modal, so no lingering tick.
            successHold: 0,
            onSuccess: () => onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(),
            toast: {
                loading: 'Creating your dare...',
                success: 'Dare created',
                error: caught => (isLegacyError(caught) ? caught.error : caught instanceof Error ? caught.message : 'Dare cannot be created'),
            },
        });
    };
    return (<RedesignModalShell className="sm:max-w-md">
			<div className="flex w-full flex-col items-center gap-3 text-center">
				<div className="flex h-12 w-12 items-center justify-center rounded-full border border-solid border-neon-amber/30 bg-neon-amber/10">
					<VpnKeyOffOutlinedIcon sx={{ fontSize: 24 }} className="text-neon-amber"/>
				</div>
				<h2 className="font-display text-xl font-bold text-foreground">Keys are gone</h2>
				<p className="text-sm text-muted-foreground">There are no keys left for this drop right now. Do you want to accept anyway?</p>
				<p className="text-xs italic text-muted-foreground">
					You will be added to the waitlist and get a key if the brand adds more. You can still complete and deliver the dare now.
				</p>
			</div>

			<div className="flex w-full gap-2">
				<Button variant="secondary" onClick={modal.hide} disabled={loading} className="flex-1 rounded-lg text-sm">
					Cancel
				</Button>
				<Button variant="brand" loading={loading} success={success} error={error} onClick={onConfirm} className="flex-1 rounded-lg text-sm">
					Accept anyway
				</Button>
			</div>
		</RedesignModalShell>);
});
